export const itemMixin = {
    data() {
        return {
            active: false,
            childActive: false
        }
    },
    created() {

        this.active = this.item && this.item.href ? this.isLinkActive(this.item) : false
        this.childActive = this.item && this.item.child ? this.isChildActive(this.item.child) : false
        this.show = this.item && this.item.child ? this.isChildActive(this.item.child) : false
    },
    methods: {
        toggleDropdown(){
            this.show = !this.show
        },
        isLinkActive(item){

            const href = item && item.href ? item.href : '';

            // Itens de ação (href '#') nunca são "link ativo".
            if (!href || href === '#') return false;

            if(this.$route){

                const path = this.$route.path;
                // Ativo quando o caminho é exatamente o href OU um filho dele (href + '/...').
                // Evita falso-positivo entre rotas irmãs com prefixo comum sem separador
                // (ex.: /admin/almox-estoque vs /admin/almox-estoque-abaixo-minimo),
                // preservando o realce em telas de edição (ex.: /admin/modelo/edit/5).
                return path === href || path.indexOf(href + '/') === 0;
            } else {
                return href == window.location.pathname
            }
        },
        isChildActive(child) {
            for (let item of child) {
                if (this.isLinkActive(item)) {
                    return true
                }
                if (item.child) {
                    if ( this.isChildActive(item.child) ) {
                        return true
                    }
                }
            }
            return false
        }
    },
    computed: {
        isRouterLink() {
            return this.$router && this.item && this.item.href !== undefined
        }
    },
    watch: {
        $route() {
            this.active = this.item && this.item.href ? this.isLinkActive(this.item) : false
            this.childActive = this.item && this.item.child ? this.isChildActive(this.item.child) : false
        }
    },
}